import React, { FunctionComponent } from "react";
import { style, classes } from "typestyle";
import * as csstips from "csstips";

// This needs to be defined before render to make sure that these classes will exist
// before map is rendered. It need the container with defined size to render correctly.
const mapWrapperCN = style(
  csstips.layerParent,
  csstips.flex,
  csstips.fillParent,
  {
    position: "relative",
    zIndex: 0,
  },
);
const leafletMapControlsLayerCN = style(csstips.newLayer, {
  pointerEvents: "none",
});
const leafletMapLayerCN = style(csstips.newLayer, { zIndex: 0 });

export interface IMapContainerWithUiLayersProps {
  mapElement: JSX.Element;
  uiLayers: JSX.Element[];
}

const MapContainerWithUiLayers: FunctionComponent<IMapContainerWithUiLayersProps> = ({
  mapElement,
  uiLayers,
}: IMapContainerWithUiLayersProps) => (
  <div className={mapWrapperCN}>
    {uiLayers.map((uiLayer, i: number) => (
      <div
        key={i}
        className={classes(
          leafletMapControlsLayerCN,
          style({
            zIndex: i + 1, // 0 is for map
          }),
        )}
      >
        {uiLayer}
      </div>
    ))}
    <div className={leafletMapLayerCN}>{mapElement}</div>
  </div>
);

export default MapContainerWithUiLayers;
